// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"ff600b80","149":"b357f1ed","325":"3b7bb502","458":"504d2c50","924":"b3a45ce3"}[chunkId] + ".chunk.js";
};